import axios from "axios";
import * as API_LINKS from '../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_DELIVERY_STATUS_LIST = 'FETCH_DELIVERY_STATUS_LIST'
export const RECEIVE_DELIVERY_STATUS_LIST = 'RECEIVE_DELIVERY_STATUS_LIST'
export const FAILED_DELIVERY_STATUS_LIST = 'FAILED_DELIVERY_STATUS_LIST'

export function fetchDeliveryStatusList(){
    // var loginCreds = JSON.parse(window.atob(localStorage.Automalt));
    // var auth = loginCreds.token;
    // console.log(auth)

    return (dispatch, getState) => {
        dispatch({type: FETCH_DELIVERY_STATUS_LIST});
        axios({
            method: 'post',
            url: API_LINKS.DELIVERY_STATUS_LIST_URL,
            headers: {
                // Authorization: auth
            },
            data: {
                // id_delivery_order: '1',
                // day: _day
                // date: 
                // For Parameters
            }
        })
        .then((response) => {
            // console.log(response.data)
            dispatch( {
                type: RECEIVE_DELIVERY_STATUS_LIST,
                payload: response.data
            })
            // console.log(response.data)
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error("Failed in fetching Delivery Orders List. Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_DELIVERY_STATUS_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_DELIVERY_STATUS_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_DELIVERY_STATUS_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }

        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/aTransporter-DeliveryStatusList.jsx